module.exports = __webpack_public_path__ + "img/02—02—Device List.552dd018.jpg";